import React, {Component} from 'react'
import {Ring} from 'react-konva'
import {KonvaEventObject} from 'konva/lib/Node'
import {RingElement as RingElementData} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: RingElementData
    onClick: (event: KonvaEventObject<MouseEvent>) => void
    onTransform: (event: KonvaEventObject<MouseEvent>) => void
    onDrag: (event: KonvaEventObject<DragEvent>) => void
    onRightClick: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
}

export default class RingElement extends Component<Props> {
    render() {
        const {element, draggable = true} = this.props
        return (
            <Ring
                opacity={element.opacity}
                innerRadius={element.innerRadius}
                outerRadius={element.outerRadius}
                fill={element.fill}
                strokeWidth={element.strokeWidth}
                strokeScaleEnabled={false}
                id={element.id}
                key={element.id}
                draggable={draggable}
                stroke={element.stroke}
                x={element.x}
                y={element.y}
                scaleX={element.scaleX}
                scaleY={element.scaleY}
                rotation={element.rotation}
                onClick={this.props.onClick}
                onTransform={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}/>
        )
    }
}
